import NoteReplyModel from 'models/NoteReplyModel';

export default Backbone.Collection.extend({
    model: NoteReplyModel,
    url: '/notes.json'
}, {
    type: 'noteReplies'
})
